import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Home = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Home' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,11 L12,2 L23,11 M15,23 L15,15 L15,15 L9,15 L9,23 M4,23 L4,9 M20,23 L20,9' />
  </StyledIcon>
);
